/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type Maybe from 'graphql/tsutils/Maybe';

import { type IconProps, breakpoints } from '@coursera/cds-core';

const statsInfoStyles = {
  container: css`
    border-right: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    display: inline-block;
    padding: var(--cds-spacing-50) var(--cds-spacing-150);
    color: var(--cds-color-neutral-primary-weak);
    ${breakpoints.down('md')} {
      :nth-child(odd) {
        padding-left: 0;
      }

      :nth-child(even) {
        border-right: 1px solid transparent;
      }
    }
  `,
  borderRightTransparent: css`
    border-right: 1px solid transparent;
  `,
  icon: css`
    margin-right: var(--cds-spacing-50);
    vertical-align: middle;
  `,
  description: css`
    vertical-align: middle;
  `,
};
export interface StatsInfoProps {
  title: string;
  count: Maybe<string>;
  Icon: React.ComponentType<IconProps>;
  hideSeparator?: boolean;
}
function StatsInfo(props: StatsInfoProps) {
  if (!props.count) {
    return null;
  }
  const { Icon } = props;
  return (
    <div css={[statsInfoStyles.container, props.hideSeparator && statsInfoStyles.borderRightTransparent]}>
      <Icon size="large" css={statsInfoStyles.icon} />
      <span css={statsInfoStyles.description}>
        {props.count}+ {props.title}
      </span>
    </div>
  );
}

export default StatsInfo;
